import React from "react";
import MessageItem from "./MessageItem";

const dotStyle = {
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: "#999",
  display: "inline-block",
  margin: "0 2px",
  animation: "aiTypingBounce 1.4s infinite ease-in-out both",
};

function getTimeStr(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  return d.getHours() + ":" + d.getMinutes();
}

const MessageList = ({ messages, isLoading }) => {
  return (
    <div className="ai-copilot-messages">
      {messages.map((msg, idx) => {
        const next = messages[idx + 1];
        const hideTimestamp =
          next &&
          next.role === msg.role &&
          getTimeStr(msg.timestamp) === getTimeStr(next.timestamp);
        return (
          <MessageItem key={msg.id} message={msg} hideTimestamp={hideTimestamp} />
        );
      })}
      {isLoading && (
        <div className="d-flex mb-2">
          <div
            className="bg-light"
            style={{
              padding: "10px 16px",
              borderRadius: "10px 10px 10px 4px",
            }}
          >
            <div className="d-flex align-items-center" style={{ height: 16 }}>
              <span style={{ ...dotStyle, animationDelay: "0s" }} />
              <span style={{ ...dotStyle, animationDelay: "0.2s" }} />
              <span style={{ ...dotStyle, animationDelay: "0.4s" }} />
            </div>
          </div>
        </div>
      )}
      <style>{`
        @keyframes aiTypingBounce {
          0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
          40% { transform: translateY(-6px); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default MessageList;
